@if(status == InvoiceVariableStatus.OK){
<!-- OK SVG -->
<div class="w-5 h-5">
    <img src="assets/icons/status/ok-empty.svg" title="{{ 'shared.status_title.ok' | transloco }}">
</div>
}
@else if(status == InvoiceVariableStatus.WARNING){
<!-- Warning SVG -->
<div class="w-5 h-5">
    <img src="assets/icons/status/warning-triangle.svg" title="{{ 'shared.status_title.warning' | transloco }}">
</div>
}
@else if(status == InvoiceVariableStatus.ERROR){
<!-- Status Error SVG -->
<div class="w-5 h-5">
    <img src="assets/icons/status/error-triangle.svg" title="{{ 'shared.status_title.error' | transloco }}">
</div>
}
@else if(status == InvoiceVariableStatus.MANDATORY_FIELD_MISSING){
<!-- Status Mandatory Field Missing SVG -->
<div class="w-5 h-5">
    <img src="assets/icons/status/error-triangle.svg" title="{{ 'shared.status_title.mandatory_field' | transloco }}">
</div>
}
@else if(status == InvoiceVariableStatus.OPTIONAL_FIELD_EMPTY){
<!-- Status Optional Field Empty SVG -->
<div class="w-5 h-5">
    <img src="assets/icons/status/warning-triangle.svg" title="{{ 'shared.status_title.optional_field' | transloco }}">
</div>
}